module.exports = __webpack_public_path__ + "files/d61f84cbd03bc7a9312cb7ca83a56bf9.png";